<nav aria-label="Main navigation" class="flex flex-col items-center w-14 h-full bg-dark-surface border-r border-dark-border py-4 gap-2">

  <!-- Dashboard nav item -->
  <a
    routerLink="/dashboard"
    routerLinkActive="text-dark-accent bg-dark-raised"
    class="flex items-center justify-center w-10 h-10 rounded-lg text-dark-text-secondary hover:text-dark-text-primary hover:bg-dark-raised transition-colors focus:outline-none focus:ring-2 focus:ring-dark-accent"
    title="{{ 'nav.dashboard' | transloco }}"
    aria-label="{{ 'nav.dashboard' | transloco }}"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5" aria-hidden="true">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  </a>

  <!-- Roster nav item — coaches only -->
  @if (isCoach()) {
    <a
      routerLink="/roster"
      routerLinkActive="text-dark-accent bg-dark-raised"
      class="flex items-center justify-center w-10 h-10 rounded-lg text-dark-text-secondary hover:text-dark-text-primary hover:bg-dark-raised transition-colors focus:outline-none focus:ring-2 focus:ring-dark-accent"
      title="{{ 'nav.roster' | transloco }}"
      aria-label="{{ 'nav.roster' | transloco }}"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    </a>
  }

  <!-- Spacer -->
  <span class="flex-1"></span>

  <!-- Profile button -->
  <app-profile-menu [initial]="profileInitial()" />

</nav>
